import React from "react";
import styles from "./JobForm.module.scss";

/**
 * Loading placeholder for the job-form survey — mirrors the JobForm layout (primary background,
 * curved card, Company/Job Title row, a couple of questions, pinned submit) so the swap to the
 * real form (or result screen) is seamless.
 */
const JobFormSkeleton = (): JSX.Element => (
  <div className={styles.jobFormBackground}>
    <div className={`${styles.card} animate-pulse`}>
      {/* Title */}
      <div className={styles.header}>
        <div className="h-6 w-44 rounded bg-neutral-4" />
      </div>

      {/* Company + Job Title */}
      <div className={styles.jobFields}>
        {[0, 1].map(i => (
          <div key={i} className={styles.jobField}>
            <div className="h-4 w-24 rounded bg-neutral-5 mb-2" />
            <div className="h-10 w-full rounded-md bg-neutral-4" />
          </div>
        ))}
      </div>

      {/* A couple of question placeholders */}
      {[0, 1].map(i => (
        <div key={i} className={styles.formComponents}>
          <div className="h-4 w-40 rounded bg-neutral-5 mb-3" />
          <div className="h-10 w-40 rounded-md bg-neutral-4" />
        </div>
      ))}

      {/* Submit */}
      <div className={styles.footer}>
        <div className="h-10 w-24 rounded-md bg-neutral-4" />
      </div>
    </div>
  </div>
);

export default JobFormSkeleton;
